import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Typography } from '../../Typography';
import { TableList } from '../TableList';
import styles from './InlineControl.module.scss';
export function InlineButton(props) {
    const { className, children, error, ref, testId, tooltipProps, disabled, onClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, className),
        "data-testid": testId,
        children: /*#__PURE__*/ _jsxs(Typography, {
            ellipsis: true,
            tooltipProps: tooltipProps,
            children: [
                children,
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.frame, styles.absolutePosition, {
                        [styles.frameDisabled]: disabled,
                        [styles.error]: error,
                        [TableList.classes.showOnRowHover]: !error
                    }),
                    children: /*#__PURE__*/ _jsx("button", {
                        ref: ref,
                        "data-testid": testId && "".concat(testId, "-btn"),
                        onClick: onClick,
                        disabled: disabled,
                        className: cn(styles.formElement, styles.absolutePosition)
                    })
                })
            ]
        })
    });
}
